import { gql } from '@apollo/client/core';
import { CATEGORY_FIELDS, SUBCATEGORY_FIELDS, TYPE_FIELDS } from '../Genre/fragments';

/**
 * Named `AnnounceDetailFields` rather than `AnnounceFields` because `src/events/Api.ts` used
 * to declare a differently-bodied `AnnounceFields`, and two same-named fragments in one
 * package make graphql-tag warn about a duplicate definition. That file is gone (sc-19349),
 * so the collision is too -- the name stays because every consumer interpolates it.
 */
export const ANNOUNCE_DETAIL_FIELDS = gql`
  fragment AnnounceDetailFields on AnnounceDetail {
    announceAt
    createdAt
    description
    eventId
    eventName
    facebookUrl
    highlightedImageIdx
    id
    images
    instagramUrl
    onSaleAt
    promoter
    support
    tags
    ticketsUrl
    ticketsUrlType
    defaultTicketsUrl
    defaultTicketsUrlNewTab
    handstampUrl
    triggeredAt
    twitterUrl
    updatedAt
    websiteUrl
    eventArtists {
      id
      artist {
        id
        name
        bio
        links {
          id
          url
        }
      }
    }
    buttonText
    tracking {
      id
      provider
      trackingId
    }
    attachments {
      attachment {
        id
        url
        status
      }
      highlighted
    }
    announceArtists {
      id
      name
      instagram
      facebook
      twitter
      website
      spotify
      youtube
      lastfm
      applemusic
      wikipedia
      songkick
      bandcamp
    }
    type {
      ...TypeFields
    }
    category {
      ...CategoryFields
    }
    subcategory {
      ...SubcategoryFields
    }
  }
  ${TYPE_FIELDS}
  ${CATEGORY_FIELDS}
  ${SUBCATEGORY_FIELDS}
`;
